module.exports = __webpack_public_path__ + "static/snowball-faq-image-09b7b8d3ee430067f0a1878dba1dd7e1.png";